import axios from "axios";

const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";
const axiosInstance = axios.create({
  // Use Vercel proxy rewrite rule for production to bypass CORS, else local backend URL
  baseURL: isLocalhost ? process.env.REACT_APP_SERVER_BASE_URL : "/api",
});

// Set default headers that will apply to all api requests
axiosInstance.defaults.headers.common["X-Api-Key"] =
  process.env.REACT_APP_API_SECRET_ACCESS_KEY;

// Add a request interceptor to include the Authorization header if a token exists
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add a response interceptor to handle portfolio setup redirect
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 403 &&
      error.response.data?.code === "PORTFOLIO_SETUP_REQUIRED"
    ) {
      window.location.href = "/dashboard/professional";
    }

    if (error.response && error.response.status === 401) {
      const requestUrl = error.config?.url || "";
      const isAuthEndpoint =
        requestUrl.includes("/auth/login") ||
        requestUrl.includes("/auth/register") ||
        requestUrl.includes("/auth/forgot-password") ||
        requestUrl.includes("/auth/reset-password") ||
        requestUrl.includes("/auth/send-otp") ||
        requestUrl.includes("/auth/verify-otp");

      if (!isAuthEndpoint) {
        localStorage.clear();
        if (window.location.pathname !== "/") {
          window.location.href = "/";
        }
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
